import { render } from "./App.vue?vue&type=template&id=9f134c76"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=stylus"
script.render = render

export default script